import { render } from "./CarType.vue?vue&type=template&id=06ca6e3e"
import script from "./CarType.vue?vue&type=script&lang=js"
export * from "./CarType.vue?vue&type=script&lang=js"

import "./CarType.vue?vue&type=style&index=0&id=06ca6e3e&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__